import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import classNames from "classnames";
import BoxEditor from "./BoxEditor";
import InvoiceList from "./lists/invoiceList";
import InvoiceForm from "./forms/invoiceForm";
import SzamlazzForm from "./forms/Invoice/SzamlazzForm";
import ExternalInvoiceForm from "./forms/Invoice/ExternalInvoiceForm";
import isEqual from 'lodash-es/isEqual';
import Button from "../form/Button";
import PrintButton from "../form/PrintButton";
import {postData} from "../../utils/request";
import {connect} from "src/store";
import TransactionPaymentEditor from "./TransactionPaymentEditor";
import {SelectButton} from "primereact/selectbutton";
import Confirm from "../form/Confirm";
import CheckBox from "../form/CheckBox";
import Portal from "../layout/Portal";
import Modal from "../layout/Modal";
import TextInput from "../form/TextInput";
import set from "../../utils/set";
import {empty} from "locutus/php/var";

export const providerTypes = {
    ExternalInvoice:  ordertype => ordertype + "" === "ExternalInvoice",
    Szamlazz: ordertype => ordertype + "" === "Szamlazz",
};

export const invoiceTypes = {
    STORNO: state => state + "" === "0",
    INVOICE: state => state + "" === "1",
    CORRECTIVE: state => state + "" === "2",
    DEPOSIT: state => state + "" === "3",
    PROFORM: state => state + "" === "999",
    EDITABLE: state => state + "" === "666",
};

class InProgress extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: 0,
            data: {}
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.values[this.props.componentConfig.idfield] !== prevProps.values[prevProps.componentConfig.idfield]) {
            this.setState({opened: 0, data: {}});
        }
    }

    updateInvoice = async (data = {}) => {
        const values = this.props.values;
        const idfield = this.props.componentConfig.idfield;
        await this.props.processAction(async () => {
            const res = await postData({
                action: "invoice.update",
                [idfield]: values[idfield],
                data: {
                    ...data,
                    [idfield]: values[idfield],
                    in_progress: 0,
                }
            });
            this.setState({
                opened: 0,
                data: {}
            });
            return res;
        });
    }

    render() {
        let content = null;
        switch (this.state.opened) {
            case 1:
                content = <Portal>
                    <Modal
                        state="on"
                        header="Számla kiállítás"
                        buttons={[
                            {
                                text: "Mégse",
                                onClose: true,
                                props: {
                                    color: "default",
                                    disabled: this.props.disabled || this.props.isLoading
                                },
                                onClick: () => this.setState({opened: 0, data: {}})
                            }
                        ]}
                    >
                        <p>A számla kiállításnál hiba történt.</p>
                        <p>Kérlek, ellenőrizd a szolgáltatónál, hogy készült-e számla.</p>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <Button
                                        color="default"
                                        block={true}
                                        onClick={() => {
                                            this.setState({opened: 2})
                                        }}
                                    >
                                        Nem készült számla
                                    </Button>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <Button
                                        color="default"
                                        block={true}
                                        onClick={() => {
                                            this.setState({opened: 3});
                                        }}
                                    >
                                        Készült számla
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </Portal>;
            break;
            case 2:
                content = <Portal>
                    <Modal
                        state="on"
                        header="Számla kiállítás"
                        buttons={[
                            {
                                text: "Mégse",
                                onClose: true,
                                props: {
                                    color: "default",
                                    disabled: this.props.disabled || this.props.isLoading
                                },
                                onClick: () => this.setState({opened: 1})
                            },
                            {
                                text: "Igen, biztos",
                                props: {
                                    color: "danger",
                                    disabled: this.props.disabled || this.props.isLoading
                                },
                                onClick: () => this.updateInvoice({})
                            }
                        ]}
                    >
                        Biztos nem készült számla?
                    </Modal>
                </Portal>;
            break;
            case 3:
                content = <Portal>
                    <Modal
                        state="on"
                        header="Számla kiállítás"
                        buttons={[
                            {
                                text: "Mégse",
                                onClose: true,
                                props: {
                                    color: "default",
                                    disabled: this.props.disabled || this.props.isLoading
                                },
                                onClick: () => this.setState({opened: 1})
                            },
                            {
                                text: "Mentés",
                                props: {
                                    color: "danger",
                                    disabled: this.props.disabled || this.props.isLoading
                                },
                                onClick: () => this.updateInvoice({billnum: this.state.data.billnum})
                            }
                        ]}
                    >
                        <div className="form-group">
                            <TextInput
                                name="billnum"
                                label="Sorszám"
                                value={this.state.data.billnum}
                                saveChanges={(field, value) => {
                                    let data = JSON.parse(JSON.stringify(this.state.data));
                                    value = value.trim();
                                    if (empty(value)) {
                                        value = null;
                                    }
                                    set(data, field, value);
                                    this.setState({data: data});
                                }}
                            />
                        </div>
                    </Modal>
                </Portal>;
            break;
        }
        if (this.props.values.in_progress + "" === "1") {
            return (
                <Fragment>
                    {content}
                    <CheckBox
                        className="pull-left"
                        checked={true}
                        label="Folyamatban"
                        saveChanges={() => {
                            this.setState({opened: 1});
                        }}
                    />
                </Fragment>
            )
        }
        return null;
    }
}

class invoiceEditor extends React.Component {

    state = {
        edit: false,
        allExternal: false,
        direction_type: ['out','in'],
    };

    constructor(props) {
        super(props);
        this.state.edit = !isEqual(this.props.values, this.props.initialValues);
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        const values = {serviceprovider_type: "ExternalInvoice", type: "999", ...this.state.allExternal};
        await this.props.setInitialValues(values);
        await this.props.setFormValues(values);
        this.editor && this.editor.focus();
    }

    updateInvoice = async (event) => {
        await this.props.saveForm(event);
        this.setState({edit: false});
        this.list && this.list.refresh();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (prevProps.values[this.props.componentConfig.idfield] !== this.props.values[this.props.componentConfig.idfield]) {
            this.setState({edit: false});
        }
    }

    cancelEdit = async () => {
        await this.props.initialForm();
        this.setState({edit: false});
    }

    createProform = async () => {
        const values = this.props.values;
        const idfield = this.props.componentConfig.idfield;
        await this.props.processAction(async () => {
            return await postData({
                action: "invoice.createProform",
                [idfield]: values[idfield]
            })
        });
    }

    render() {

        let {listFilter} = this.props;
        if (!listFilter) {
            listFilter = [];
        }

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const stornoable = !this.props.values.storno && !invoiceTypes.PROFORM(this.props.values.type) && !invoiceTypes.EDITABLE(this.props.values.type);
        const correctable =
            !providerTypes.ExternalInvoice(this.props.values.serviceprovider_type) && !(invoiceTypes.EDITABLE(this.props.values.type) || invoiceTypes.PROFORM(this.props.values.type));
        const acting = ((this.props.values || {}).acting || {}).partner_id || ((this.props.values || {}).from || {}).partner_id;
        const currentPartner = (((this.props.till || {}).pos || {}).partner || {}).partner_id;

        let Form;
        switch ((this.props.values || {}).serviceprovider_type) {
            case "Szamlazz": Form = SzamlazzForm; break;
            case "ExternalInvoice": Form = ExternalInvoiceForm; break;
            default: Form = InvoiceForm; break;
        }

        const direction_types = [
            {label: 'Kimenő', value: 'out'},
            {label: 'Bejövő', value: 'in'}
        ];
        if (!listFilter) {
            listFilter = [];
        } else {
            if (Array.isArray(listFilter)) {
                listFilter = [...listFilter];
            } else if (!listFilter) {
                listFilter = [listFilter];
            }
        }

        if (this.props.till && !this.props.client) {
            const currentPartner = (((this.props.till || {}).pos || {}).partner || {}).partner_id;
            if (JSON.stringify(this.state.direction_type) === JSON.stringify(["out"])) {
                listFilter = [...listFilter, {filters: [{field: "acting", value: currentPartner}, {field: "from", value: currentPartner}], operator: "OR"}];
            } else if (JSON.stringify(this.state.direction_type) === JSON.stringify(["in"])) {
                listFilter = [...listFilter, {field: "to", value: currentPartner}];
            }
        }

        const actionButtons = [];
        const processButtons = [];
        if (this.state.allExternal) {
            processButtons.push(
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="default"
                    onClick={this.pristineForm}
                >
                    Új
                </Button>
            );
            if (invoiceTypes.PROFORM(this.props.values.type) || providerTypes.ExternalInvoice(this.props.values.serviceprovider_type)) {
                actionButtons.push(
                    <Button
                        key="1"
                        disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                        color="danger"
                        className="pull-left"
                        onClick={this.props.deleteForm}
                    >
                        Törlés
                    </Button>
                );
            }
        }
        if (!this.props.values.billnum && invoiceTypes.PROFORM(this.props.values.type)) {
            actionButtons.push(
                <Button
                    key="9"
                    disabled={!this.props.values[this.props.componentConfig.idfield]}
                    color="default"
                    className="pull-right"
                    onClick={this.createProform}
                >
                    Proforma készítése
                </Button>
            );
        }

        return (
            <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Számlák"}
                    footer={processButtons}
                    actions={!!this.props.till && !this.props.client && <SelectButton
                        value={this.state.direction_type}
                        multiple={true}
                        options={direction_types}
                       onChange={(e) => this.setState({direction_type: e.value.length ? e.value : this.state.direction_type})}
                    />}
                >
                    <InvoiceList
                        ref={(el) => this.list = el}
                        {...this.props}
                        listFilter={listFilter}
                        loadForm={this.loadForm}
                        isAllExternal={(allExternal) => this.setState({allExternal})}
                    />
                </List>
                {(this.props.values[this.props.componentConfig.idfield] || this.state.allExternal) && <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={(this.props.values.billnum || "") + " Számla"}
                    footer={
                        !this.state.edit ?
                            <Fragment>
                                <InProgress {...this.props} />
                                {this.props.values.billnum && !this.state.edit && <PrintButton
                                    {...this.props}
                                    color="primary"
                                    className="pull-right"
                                    disabled={this.props.isLoading}
                                />}
                                {
                                    !correctable
                                    ?
                                        <Fragment>
                                            <Button
                                                key="0"
                                                disabled={!this.props.dirty || this.props.isLoading}
                                                color="primary"
                                                className="pull-right"
                                                onClick={this.props.saveForm}
                                            >
                                                Mentés
                                            </Button>
                                            {actionButtons}
                                        </Fragment>
                                    :
                                        (stornoable && <Button
                                            onClick={() => this.setState({edit: true})}
                                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                                            color="warning"
                                            className="pull-right"
                                        >
                                            Javítás
                                        </Button>)
                                }
                                {acting + "" === "" + currentPartner && !!this.props.values.billnum && <Button
                                    onClick={async () => await this.props.processAction(async ({componentAction}) => await componentAction("sendNotification"))}
                                    disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                                    color="warning"
                                    icon={{lib: "far", name: "paper-plane"}}
                                    className="pull-right"
                                >
                                    Küldés
                                </Button>}
                            </Fragment>
                            :
                            <Fragment>
                                <Button
                                    onClick={this.updateInvoice}
                                    disabled={!this.props.values[this.props.componentConfig.idfield] || !this.props.dirty || this.props.isLoading}
                                    color="primary"
                                    className="pull-right"
                                >
                                    Javítás
                                </Button>
                                <Button
                                    onClick={this.cancelEdit}
                                    disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                                    color="default"
                                    className="pull-right"
                                >
                                    Mégse
                                </Button>
                            </Fragment>
                    }
                >
                    <Form {...this.props} providerTypes={providerTypes} invoiceTypes={invoiceTypes} correctable={correctable} edit={!correctable || this.state.edit} />
                </Editor>}
                {this.props.values[this.props.componentConfig.idfield] && <TransactionPaymentEditor
                    presets={{transaction: this.props.values.transaction.id}}
                    listFilter={[{
                        field: "transaction",
                        value: this.props.values.transaction.id
                    }]}
                />}
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(createEditor({
    componentName: "invoice",
    WrappedComponent: invoiceEditor,
    props: {
        view: "admin",
        componentActions: async (action, data, params, componentConfig) => {
            if (!providerTypes.ExternalInvoice(data.serviceprovider_type) && !(invoiceTypes.EDITABLE(data.type) || invoiceTypes.PROFORM(data.type))) {
                return {
                    action: "updateInvoice",
                    data: {
                        [componentConfig.idfield]: data[componentConfig.idfield],
                        accountdate: data.accountdate,
                        transactiondate: data.transactiondate,
                        deadline: data.deadline,
                        comment: data.comment,
                    },
                    params
                };
            } else {
                data = await referenceActionData(data, componentConfig);
                return {action,data,params};
            }
        }
    }
}));

